export default "__VITE_ASSET__WiszFlkS__"